<template>
  <p v-if="visible">
    {{text}}
    <span v-if="text && text.length>maxChar">
      <a href="#" @click.stop.prevent="visible=false">[weniger]</a>
    </span>
  </p>
  <p v-else>
  <span v-if="text && text.length>maxChar">
      {{cuttedText}}...
      <a href="#" @click.stop.prevent="visible=true">[mehr]</a>
  </span>
  <span v-else>
    {{text}}
  </span>
  </p>
</template>

<script>
export default {
  name: 'ShortDescription',
  props:{
    text:{
      type:String
    }
  },
  data: function() {
    return {
       visible:false,
       maxChar:300
    };
  },
  computed:{
    cuttedText(){
      return this.text.substring(0, this.maxChar)
    }
  },
  methods:{
    show(){
      this.visible=true;
    },
    hide(){
      this.visible=false;
    }
  }
};
</script>

<style type='text/css'>

</style>